import { API, graphqlOperation } from 'aws-amplify';
import { processChatRequest as processChatRequestMutation } from './graphql/mutations';

interface ProcessChatRequestProps {
  input: string;
  sessionId?: string;
  isInitialPrompt?: boolean;
  userId: string | number;
}

export const processChatRequest = async (body: ProcessChatRequestProps) => {
  const { data } = await API.graphql(graphqlOperation(processChatRequestMutation, { input: body }));

  return data;
};
